import React from 'react';
import {Link} from 'react-router-dom'

const PaymentSettingsModal = ({
  closeModal
}) => (
  <div style={{ backgroundColor: '#FAFAFA', width: '450px' }} className="py-8 px-12">
    <h2 class="font-bold text-xl font-title">Autopay information</h2>
      <p className="py-4">Because we care about making sure you start off on the right foot with your credit score, every customer starts off with 7 day autopay. In order to unlock this feature, you must first prove you are a responsible borrower and have up to 3 months of on-time payments. If you’d like more information or have any questions about unlocking this feature, please <Link className='underline hover:underline' to='/support' onClick={closeModal}>contact us</Link>.</p>
    <p className="text-center">
      <button className="underline" onClick={closeModal}>close</button>
    </p>
  </div>
);

export default PaymentSettingsModal;
